import React from 'react';
import './footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-container">
                <p>&copy; {currentYear} Video Manager.</p>
                <p className="footer-subtitle">Sistema de Gestión de Videos Comerciales</p>

            </div>
        </footer>
    );
};

export default Footer;
